import { SerializedError, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Reservation } from "data/types";
import { reservation } from "./featureAPI";

interface ReservationState {
  loading: "idle" | "pending" | "succeeded" | "failed";
  reservationError: string;
  error: SerializedError | "";
  reservationData?: Reservation;
  count: number;
}

const initialState = {
  allInvoices: {
    invoices: [],
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
  },
  totalCount: 0,
  feedbacks: [],
  totalPages: 0,
  currentPage: 0,
  count: 0,
  reservationData: undefined,
  status: "",
  loading: "idle",
  reservations: [],
  reservationOwner: [],
  canceledByClient: [],
  tentative: [],
  enAttente: [],
  inProgress: [],
  totalAmount: 0,
  canceledByOwner: [],
  pending: [],
  availableHours: [],
  fullyDays: [],
  unavailableDays: [],
  sessionUrl: "",
  message: "",
  reservationDetail: {
    payment_status: "",
    id: "",
    map: "",
    selectedDate: "",
    startHour: "",
    endHour: "",
    validation: true,
    visitor: 0,
    locationId: "",
    ownerId: "",
    clientId: "",
    price: 0,
    Location: {
      map: "",
      atmosphere: [],
      playground: [],
      availableDays: "[]",
      events: [],
      comments: { roundedMoyenne: 0, comments: [] },
      comment: { loading: "" },
      equipments: [],
      extras: [],
      conditions: [],
      ownerLocations: [],
      images: [],
      id: null,
      title: "",
      description: "",
      region: null,
      address: "",
      address2: "",
      city: "",
      visitor: null,
      surface: "",
      light: false,
      price: "",
      startHour: "",
      endHour: "",
      parking: "",
      water: false,
      wc: "",
      handicap: false,
      guarantee: null,
      validation: false,
      location_url: null,
      createdAt: null,
      updatedAt: null,
      ownerId: null,
      categoryLocationId: null,
      CategoryLocation: {
        id: null,
        designation: "",
        createdAt: null,
        updatedAt: null,
      },
    },
    Owner: {
      id: null,
      name: "",
      lastName: "",
      identityNumber: "",
      rib: "",
      bank: "",
      phone: "",
      birthday: null,
      identityFImg_url: "",
      identityBImg_url: "",
      adresseImg_url: "",
      pays: null,
      companyCertifImg_url: "",
      companyName: "",
      companySiren: "",
      adresse: "",
      codePostale: "",
      suppAdresse: "",
      ville: "",
      iban_url: "",
      owner_url: "",
      validation: false,
      category: "",
      createdAt: null,
      updatedAt: null,
      userId: null,
    },
    Client: { userId: "" },
  },
};

export const repayReservationFee = createAsyncThunk("featureReservation/repayReservationFee", async (id: any) => {
  return await reservation.repayment(id);
});

export const cancelReservation = createAsyncThunk("featureReservation/cancelReservation", async (data: any) => {
  return await reservation.sendCancelEmail(data);
});

export const fetchReservationByLocation = createAsyncThunk(
  "featureReservation/fetchReservationByLocation",
  async (id: any) => {
    return await reservation.getReservationByLocations(id);
  }
);
export const fetchReservation = createAsyncThunk(
  "featureReservation/fetchReservation",
  async (pageNumber: number) => {
    return await reservation.getReservations(pageNumber);
  }
);

export const fetchReservationToPay = createAsyncThunk(
  "featureReservation/fetchReservationToPay",
  async (pageNumber: number) => {
    return await reservation.getReservationsToPay(pageNumber);
  }
);

export const fetchOwnerTransferts = createAsyncThunk(
  "featureReservation/fetchOwnerTransactions",
  async ({ pageNumber }: { pageNumber: number }) => {
    return await reservation.getOwnerAllTransferts(pageNumber);
  }
);

export const fetchUserInvoices = createAsyncThunk(
  "featureReservation/getUserReservationInvoice",
  async ({ page, searchTerm }: { page: number; searchTerm: string }) => {
    return await reservation.getUserReservationInvoice(page, searchTerm);
  }
);

export const getOwnerReservationBalance = createAsyncThunk(
  "featureReservation/fetchOwnerTransactions2",
  async () => {
    return await reservation.getOwnerReservationBalance();
  }
);

export const fetchOwnerTransfertsGain = createAsyncThunk(
  "featureReservation/fetchOwnerTransfertsGain",
  async ({ pageNumber }: { pageNumber: number }) => {
    return await reservation.getOwnerAllTransfertsGain(pageNumber);
  }
);

export const transfertAmountOwner = createAsyncThunk(
  "featureReservation/transfertAmountOwner",
  async ({ amount, owner_id }: { amount: number; owner_id: string }) => {
    return await reservation.transfertAmountOwner(amount, owner_id);
  }
);

export const fetchTentativeReservation = createAsyncThunk(
  "featureReservation/fetchTentativeReservation",
  async ({ page, reference }: { page: number; reference: string }) => {
    return await reservation.getTentativeReservations(page, reference);
  }
);

export const fetchAvailableHours = createAsyncThunk(
  "featureReservation/fetchAvailableHours",
  async ({ id, selectedDay, type }: { id: any; selectedDay: any; type: string }) => {
    return await reservation.getAvailableHours(id, selectedDay, type);
  }
);
export const fetchfullyDays = createAsyncThunk(
  "featureReservation/fetchfullyDays",
  async ({ id, type }: { id: any; type: string }) => {
    return await reservation.getFullyBookedDays(id, type);
  }
);

export const fetchfullDays = createAsyncThunk("featureReservation/fetchfullDays", async (id: any) => {
  return await reservation.getFullBookedDays(id);
});

export const fetchReservationById = createAsyncThunk(
  "featureReservation/fetchReservationById",
  async (id: any) => {
    return await reservation.getReservationById(id);
  }
);
export const checkReservationByReference = createAsyncThunk(
  "featureReservation/checkReservationByReference",
  async (ref: any) => {
    return await reservation.checkReservationByReference(ref);
  }
);
export const fetchAdminCanceledReservationByClient = createAsyncThunk(
  "featureReservation/getCancledReservation",
  async (pageNumber: number) => {
    return await reservation.fetchAdminCanceledReservationByClient(pageNumber);
  }
);
export const payRefundReservation = createAsyncThunk(
  "featureReservation/payRefundReservation",
  async (ref: any) => {
    return await reservation.payRefundReservation(ref);
  }
);
export const payPartialRefundReservation = createAsyncThunk(
  "featureReservation/payPartialRefundReservation",
  async (ref: any) => {
    return await reservation.payPartialRefundReservation(ref);
  }
);

export const updateReservation = createAsyncThunk(
  "featureReservation/editReservation",
  async ({ data, id }: { data: any; id: any }) => {
    return await reservation.update(data, id);
  }
);
export const confirmReservation = createAsyncThunk(
  "featureReservation/confirmReservation",
  async ({ data, id }: { data: any; id: any }) => {
    return await reservation.confirm(data, id);
  }
);

export const fetchReservationByClient = createAsyncThunk(
  "featureReservation/fetchReservationByClient",
  async ({ id, page }: { id: any; page: any }) => {
    return await reservation.getReservationByClient(id, page);
  }
);

export const fetchReservationByOwner = createAsyncThunk(
  "featureReservation/fetchReservationByOwner",
  async ({ id, page }: { id: any; page: any }) => {
    return await reservation.getReservationByOwner(id, page);
  }
);

export const fetchReservationByOwnerAsClient = createAsyncThunk(
  "featureReservation/fetchReservationByOwnerAsClient",
  async ({ id, page }: { id: any; page: any }) => {
    return await reservation.getReservationByOwnerAsClient(id, page);
  }
);

export const fetchAdminCanceledReservationByOwner = createAsyncThunk(
  "featureReservation/fetchPendingReservation",
  async (pageNumber: number) => {
    return await reservation.fetchAdminCanceledReservationByOwner(pageNumber);
  }
);

export const fetchEnAttenteReservation = createAsyncThunk(
  "featureReservation/fetchEnAttenteReservation",
  async (pageNumber: number) => {
    return await reservation.getEnAttenteReservation(pageNumber);
  }
);

export const fetchPendingOwnerReservation = createAsyncThunk(
  "featureReservation/fetchPendingOwnerReservation",
  async ({ id, page }: { id: any; page: any }) => {
    return await reservation.getPendingOwnerReservation(id, page);
  }
);
export const fetchBlockedReservationByOwner = createAsyncThunk(
  "featureReservation/fetchBlockedReservationByOwner",
  async (id: any) => {
    return await reservation.getBlockedReservationByOwner(id);
  }
);

export const fetchSubscriptionDetails = createAsyncThunk(
  "featureReservation/fetchSubscriptionDetails",
  async (id: any) => {
    return await reservation.fetchSubscriptionDetails(id);
  }
);

export const saveReservation = createAsyncThunk("featureReservation/saveReservation", async (formData: any) => {
  return formData;
});

export const deleteReservation = createAsyncThunk("featureReservation/deleteReservation", async (id: any) => {
  return await reservation.deleteReservation(id);
});
export const payReservation = createAsyncThunk("featureReservation/payReservation", async (data: any) => {
  return await reservation.payReservation(data);
});

export const paySubscription = createAsyncThunk("featureReservation/paySubscription", async (data: any) => {
  return await reservation.paySubscription(data);
});
export const payReservationOwner = createAsyncThunk(
  "featureReservation/payReservationOwner",
  async (data: any) => {
    return await reservation.payReservationOwner(data);
  }
);
export const checkReservation = createAsyncThunk("featureReservation/checkReservation", async (data: any) => {
  return await reservation.checkReservation(data);
});

export const makeReservationOwner = createAsyncThunk(
  "featureReservation/makeReservationOwner",
  async (data: any) => {
    return await reservation.makeReservationOwner(data);
  }
);

export const filterAllReservation = createAsyncThunk("filterAllReservation", async (data: any) => {
  return await reservation.filterAllReservation(data);
});

export const fetchTerminatedReservationByClient = createAsyncThunk(
  "featureReservation/fetchTerminatedReservationByClient",
  async (id: any) => {
    return await reservation.getTerminatedReservationByClient(id);
  }
);

export const sendReservationFeedback = createAsyncThunk(
  "featureReservation/sendReservationFeedback",
  async (data: any) => {
    return await reservation.sendReservationFeedback(data);
  }
);

export const adminGetAllFeedbacks = createAsyncThunk(
  "adminGetAllFeedbacks",
  async ({ page, reference }: { page: number; reference: string }) => {
    return await reservation.adminGetAllFeedbacks(page, reference);
  }
);

export const getAllFeedbacksByUserId = createAsyncThunk(
  "getAllFeedbacksByUserId",
  async ({ page, reference }: { page: number; reference: string }) => {
    return await reservation.getAllFeedbacksByUserId(page, reference);
  }
);

export const deleteReservationFeedback = createAsyncThunk(
  "featureReservation/deleteReservationFeedback",
  async (reference: string) => {
    return await reservation.deleteReservationFeedback(reference);
  }
);

const reservationSlice = createSlice({
  name: "featureReservation",
  initialState,
  reducers: {
    initialState(state) {
      state.status = "";
      state.loading = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendReservationFeedback.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(sendReservationFeedback.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(sendReservationFeedback.rejected, (state) => {
        state.loading = "failed";
      });

    builder
      .addCase(deleteReservationFeedback.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deleteReservationFeedback.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deleteReservationFeedback.rejected, (state) => {
        state.loading = "failed";
      });

    builder
      .addCase(adminGetAllFeedbacks.pending, (state) => {
        state.status = "loading";
      })
      .addCase(adminGetAllFeedbacks.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.feedbacks = action.payload?.feedbacks;
        state.totalCount = action.payload?.totalCount || 0;
        state.totalPages = action.payload?.totalPages || 0;
        state.currentPage = action.payload?.currentPage || 1;
      })
      .addCase(adminGetAllFeedbacks.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(getAllFeedbacksByUserId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllFeedbacksByUserId.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.feedbacks = action.payload?.feedbacks;
        state.totalCount = action.payload?.totalCount || 0;
        state.totalPages = action.payload?.totalPages || 0;
        state.currentPage = action.payload?.currentPage || 1;
      })
      .addCase(getAllFeedbacksByUserId.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(confirmReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(confirmReservation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload;
      })
      .addCase(confirmReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(payRefundReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(payRefundReservation.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(payRefundReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(payPartialRefundReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(payPartialRefundReservation.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(payPartialRefundReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(makeReservationOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(makeReservationOwner.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(makeReservationOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(cancelReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(cancelReservation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.reservationDetail = action.payload;
      })
      .addCase(cancelReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationByLocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationByLocation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload;
      })
      .addCase(fetchReservationByLocation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchAdminCanceledReservationByClient.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAdminCanceledReservationByClient.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.canceledByClient = action.payload.reservations;
      })
      .addCase(fetchAdminCanceledReservationByClient.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchTentativeReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTentativeReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.tentative = action.payload.reservations;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchTentativeReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.inProgress = action.payload.reservations;
      })
      .addCase(fetchReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationToPay.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationToPay.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.inProgress = action.payload.reservations;
      })
      .addCase(fetchReservationToPay.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationById.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservationDetail = action.payload;
      })
      .addCase(fetchReservationById.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(checkReservationByReference.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkReservationByReference.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservationDetail = action.payload.reservation;
        state.message = action.payload.message;
      })
      .addCase(checkReservationByReference.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationByClient.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationByClient.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload.Reservation;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchReservationByClient.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchTerminatedReservationByClient.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTerminatedReservationByClient.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload;
      })
      .addCase(fetchTerminatedReservationByClient.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationByOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationByOwner.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload.reservations;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchReservationByOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchReservationByOwnerAsClient.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReservationByOwnerAsClient.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservationOwner = action.payload.Reservation;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchReservationByOwnerAsClient.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchAdminCanceledReservationByOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAdminCanceledReservationByOwner.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.canceledByOwner = action.payload.reservations;
      })
      .addCase(fetchAdminCanceledReservationByOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchEnAttenteReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEnAttenteReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.enAttente = action.payload.reservations;
      })
      .addCase(fetchEnAttenteReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchPendingOwnerReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPendingOwnerReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload.reservations;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchPendingOwnerReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchBlockedReservationByOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBlockedReservationByOwner.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload;
      })
      .addCase(fetchBlockedReservationByOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchSubscriptionDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSubscriptionDetails.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservations = action.payload;
      })
      .addCase(fetchSubscriptionDetails.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(saveReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(saveReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservationDetail = action.payload;
      })
      .addCase(saveReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(payReservationOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(payReservationOwner.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.message = action.payload;
      })
      .addCase(payReservationOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchAvailableHours.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchAvailableHours.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.availableHours = action.payload;
      })
      .addCase(fetchAvailableHours.rejected, (state) => {
        state.loading = "failed";
      });

    builder
      .addCase(fetchfullyDays.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchfullyDays.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.fullyDays = action.payload;
      })
      .addCase(fetchfullyDays.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchfullDays.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchfullDays.fulfilled, (state, action) => {
        state.loading = "succeeded";

        state.fullyDays = action.payload?.fullyBookedDays;
        state.unavailableDays = action?.payload?.unavailbaleDays;
      })
      .addCase(fetchfullDays.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(payReservation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(payReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.sessionUrl = action.payload;
      })
      .addCase(payReservation.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(paySubscription.pending, (state) => {
        state.status = "loading";
      })
      .addCase(paySubscription.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.sessionUrl = action.payload;
      })
      .addCase(paySubscription.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(repayReservationFee.pending, (state) => {
        state.status = "loading";
      })
      .addCase(repayReservationFee.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.sessionUrl = action.payload;
      })
      .addCase(repayReservationFee.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(filterAllReservation.pending, (state, action) => {
        state.loading = "pending";
      })
      .addCase(filterAllReservation.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.reservationData = action.payload;
      })
      .addCase(filterAllReservation.rejected, (state, action) => {
        state.reservationData = undefined;
        state.loading = "failed";
      });

    builder
      .addCase(fetchOwnerTransferts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOwnerTransferts.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.inProgress = action.payload.reservations;
      })
      .addCase(fetchOwnerTransferts.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(getOwnerReservationBalance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOwnerReservationBalance.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.totalAmount = action.payload.totalAmount;
      })
      .addCase(getOwnerReservationBalance.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(transfertAmountOwner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(transfertAmountOwner.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(transfertAmountOwner.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchOwnerTransfertsGain.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOwnerTransfertsGain.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.inProgress = action.payload.reservations;
      })
      .addCase(fetchOwnerTransfertsGain.rejected, (state) => {
        state.status = "failed";
      });

    builder
      .addCase(fetchUserInvoices.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchUserInvoices.fulfilled, (state, action) => {
        state.allInvoices = {
          invoices: action.payload.invoices,
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
        };
        state.loading = "succeeded";
      })
      .addCase(fetchUserInvoices.rejected, (state, action) => {
        state.loading = "failed";
      });
  },
});

export const {} = reservationSlice.actions;
export default reservationSlice.reducer;
